import { render, staticRenderFns } from "./BuscarClientes.vue?vue&type=template&id=4ddca6b4"
import script from "./BuscarClientes.vue?vue&type=script&lang=js"
export * from "./BuscarClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports